var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1220_22685",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 16.98c.24 0 .443-.082.606-.245a.823.823 0 00.244-.605.823.823 0 00-.244-.606.823.823 0 00-.606-.244.823.823 0 00-.606.244.823.823 0 00-.244.606c0 .24.081.442.244.605a.823.823 0 00.606.245zm0-3.846a.763.763 0 00.563-.227.763.763 0 00.226-.563V7.607a.764.764 0 00-.227-.562.765.765 0 00-.562-.227.763.763 0 00-.563.227.764.764 0 00-.226.562v4.737c0 .224.075.411.227.563a.764.764 0 00.562.227zM12.002 22a9.742 9.742 0 01-3.9-.787 10.099 10.099 0 01-3.176-2.137A10.1 10.1 0 012.788 15.9a9.733 9.733 0 01-.788-3.9c0-1.382.262-2.682.787-3.9a10.1 10.1 0 012.137-3.175A10.1 10.1 0 018.1 2.788a9.733 9.733 0 013.9-.788c1.382 0 2.682.262 3.9.787a10.101 10.101 0 013.175 2.137A10.1 10.1 0 0121.212 8.1a9.733 9.733 0 01.788 3.9 9.742 9.742 0 01-.787 3.9 10.1 10.1 0 01-2.137 3.175 10.1 10.1 0 01-3.175 2.138 9.733 9.733 0 01-3.9.788zM12 20.421c2.35 0 4.342-.816 5.974-2.447C19.605 16.342 20.42 14.35 20.42 12c0-2.35-.816-4.342-2.447-5.974C16.342 4.395 14.35 3.58 12 3.58c-2.35 0-4.342.816-5.974 2.447C4.395 7.658 3.58 9.65 3.58 12c0 2.35.816 4.342 2.447 5.974C7.658 19.605 9.65 20.42 12 20.42z",
    fill: "currentColor"
  }))));
}
SvgError.displayName = 'Error';
export default SvgError;